export default __webpack_public_path__ + "static/media/FormatoPropuestaTecnica_invitacionpublica.f91550fc.docx";